// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //googleMapsAPIKey: 'AIzaSyB77OC0QNHhmHrPBtWXKLZfMSN-HvKX-ZE',
  //googleMapsAPIKey: 'AIzaSyD0uzvQwtx6lfoSDnHb--uwOXYjOtuJuaU',
  googleMapsAPIKey: 'AIzaSyCgjJHWaoOmTBuU_iScLrr_bccy-xlpbMM',
   endpoint: 'https://api.ezvolt.com/api/',
  //endpoint: 'http://127.0.0.1:8000/api/',
  socket: 'https://com.ai-tech.ltd:443',
  googleApiKey: 'AIzaSyB77OC0QNHhmHrPBtWXKLZfMSN-HvKX-ZE',
  stripeKey: 'pk_live_51MU2EMCcuF6nhyS8752ZcS0YwSlgjKBXoGXlpSWQd3Nwt2KRBbuafwZCxdGKtwWQU07VlaSgT9E5S62BY3KpeluC00baOPNI9g'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
